export default __webpack_public_path__ + "efda31c8d125e2a37f41672d36b173b0.svg";